import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  color: theme.palette.secondary.main,
  '& p:not(.MuiTypography-root),& ol,& ul': {
    // styling for the P,ol,ul written in the translation file
    marginTop: theme.spacing(1.25),
    marginBottom: theme.spacing(1.25),
  },
}));

export default StyledBox;
